export function createImportRepository(config) {
    const { repository, client } = config;
    return {
    // useCreate(context) {
    //     const queryClient = useQueryClient();
    //     return repository.useMutation(context, {
    //         async mutationFn(props) {
    //             const response = await client.user.default.importUpload({
    //                 file: props.file,
    //             });
    //             return response.data;
    //         },
    //         async onSuccess(data, variables, context) {
    //             await Promise.all([
    //                 queryClient.refetchQueries({
    //                     // TODO proper type-safety
    //                     queryKey: ['import', 'list'],
    //                 }),
    //                 queryClient.refetchQueries({
    //                     // TODO proper type-safety
    //                     queryKey: ['research', 'content'],
    //                 }),
    //             ]);
    //         },
    //     });
    // },
    };
}
//# sourceMappingURL=importRepository.js.map